/**
 * Remote config.
 *
 * @note These are remote-controlled via GameAnalytics!
 * The values will be overriden by the remove config.
 *
 * Keys need to be 1-16 characters.
 *
 * ## Shorthand Legend
 *
 * MP = "Multiplier"
 * I = "Interval"
 */
export const Config = {
    /** Tutorial type */
    tutorialType: 'short' as 'long' | 'short',

    /** Whether to skip the menu after the tutorial */
    tutorialSkipMenu: true,
};
